import { events } from '../names';
import { useSendEvent } from '../useSendEvent';

enum EmailConfirmationAction {
	OpenInbox = 'out_email',
}

enum OnboardingStep {
	EmailConfirmation = 'email-verification-step1',
	EmailConfirmed = 'email-verification-step2',
	Paywall = 'ai-paywall',
}

export const useOnboardingFinished = () =>
	useSendEvent(events.onboarding.finished);

export const useClickConfirmEmailCredits = () =>
	useSendEvent(events.onboarding.clickConfirmEmailCredits);

const EmailConfirmationOpenInboxParams = {
	'step-name': OnboardingStep.EmailConfirmation,
	value: EmailConfirmationAction.OpenInbox,
};

export const useEmailConfirmationOpenInbox = () =>
	useSendEvent(events.onboarding.steps, EmailConfirmationOpenInboxParams);

const EmailVerificationPaywallParams = {
	'step-name': OnboardingStep.Paywall,
	value: 1,
};

export const useEmailVerificationPaywall = () =>
	useSendEvent(events.onboarding.steps, EmailVerificationPaywallParams);

const EmailConfirmedParams = {
	'step-name': OnboardingStep.EmailConfirmed,
	value: 1,
};

export const useEmailVerificationConfirmed = () =>
	useSendEvent(events.onboarding.steps, EmailConfirmedParams);
